export function planFeatures(user) {
  const fromApi = user?.tenant?.plan_features;
  if (fromApi) return fromApi;
  if (user?.tenant?.subscription_plan === 'free') {
    return {
      plan: 'free',
      performance: false,
      max_disciplines: 1,
      max_locations: 1,
      max_students: 30,
    };
  }
  return {
    plan: 'premium',
    performance: true,
    max_disciplines: null,
    max_locations: null,
    max_students: null,
  };
}

export function atPlanLimit(count, max) {
  return max != null && count >= max;
}
